<template>
  <span class="mts-readonly-number" v-bind="attrs"> {{ suffix }}{{ getValue }}{{ suffix }} </span>
</template>

<script lang="ts" setup>
  import { computed, HTMLAttributes, useAttrs } from 'vue';
  import { getLocaleStore } from '@/store';

  defineOptions({ name: 'ReadonlyNumber', inheritAttrs: false });

  const props = defineProps<{
    value?: string | number;
    prefix?: string;
    suffix?: string;
    precision?: number;
    options?: Intl.NumberFormatOptions;
  }>();
  const attrs = useAttrs() as HTMLAttributes;

  const getValue = computed(() => {
    const value = props.value ?? attrs['text'];
    if (!value && value !== 0) return;

    const num = +value;
    if (Number.isNaN(num)) return value;

    const { options = {}, precision } = props;
    return new Intl.NumberFormat(getLocaleStore().getLocale, {
      style: 'decimal',
      ...options,
      minimumFractionDigits: options.minimumFractionDigits ?? (precision ? precision : 0),
      maximumFractionDigits: options.maximumFractionDigits ?? (precision ? precision : 5),
    }).format(num);
  });
</script>
